import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const ChannelFreestyleIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.3125H1.99999C1.66834 2.3125 1.3125 2.60712 1.3125 3.07999V12.92C1.3125 13.3929 1.66834 13.6875 1.99999 13.6875H14C14.3317 13.6875 14.6875 13.3929 14.6875 12.92V3.07999C14.6875 2.60712 14.3317 2.3125 14 2.3125ZM1.99999 1H14C15.1046 1 16 1.93124 16 3.07999V12.92C16 14.0688 15.1046 15 14 15H1.99999C0.895427 15 0 14.0688 0 12.92V3.07999C0 1.93124 0.895427 1 1.99999 1Z"
        fill="#F7F9FD"
      />
      <path
        d="M4.56557 11.0896C4.48418 11.1573 4.36524 11.0981 4.36524 10.9999V9.80004C4.36551 9.78307 4.36948 9.76627 4.37698 9.75076C4.38448 9.73524 4.39541 9.7213 4.40905 9.7101L6.54648 7.94529L6.57926 7.91824L6.54648 7.8912L4.40911 6.12644L4.40829 6.12577C4.37997 6.10376 4.36524 6.07201 4.36524 6.03673V4.83658C4.36513 4.81446 4.37143 4.79245 4.38367 4.77352C4.3959 4.75454 4.41351 4.73919 4.43471 4.7295C4.45586 4.71982 4.47951 4.71623 4.50278 4.71937C4.52604 4.72245 4.54779 4.73202 4.5654 4.74675L8.30309 7.82657C8.36028 7.87395 8.36028 7.96058 8.30309 8.00796L4.56557 11.0896ZM8.52663 11.1184C8.46585 11.1184 8.41426 11.0655 8.41426 10.9999V10.0811C8.41426 10.0155 8.46585 9.96266 8.52663 9.96266H12.1279C12.1886 9.96266 12.2402 10.0155 12.2402 10.0811V10.9999C12.2402 11.0655 12.1886 11.1184 12.1279 11.1184H8.52663Z"
        fill="#F7F9FD"
      />
    </SvgIcon>
  ))
);
